module.exports = __webpack_public_path__ + "static/media/33000140.cff1ca95.jpg";